import React from 'react';
import PropTypes from 'prop-types';
import { VDGroup } from 'mr-components';

const VolumeDiscountGroupPreview = ({
  isShowVDViewProductsButton,
  vdGroupOfItemsPageURL,
  theme,
  isMobile,
  vdOptions,
  discountType,
  decimalSymbol,
  thousandSeparator,
  currencyFormat,
  currencySymbol,
}) => (
  <VDGroup
    isShowVDViewProductsButton={isShowVDViewProductsButton}
    vdGroupOfItemsPageURL={vdGroupOfItemsPageURL}
    theme={theme}
    isMobile={isMobile}
    vdOptions={vdOptions}
    discountType={discountType}
    currencySymbol={currencySymbol}
    currencyFormat={currencyFormat}
    decimalSymbol={decimalSymbol}
    thousandSeparator={thousandSeparator}
  />
);

export default VolumeDiscountGroupPreview;

VolumeDiscountGroupPreview.propTypes = {
  isShowVDViewProductsButton: PropTypes.bool,
  vdGroupOfItemsPageURL: PropTypes.string,
  theme: PropTypes.object,
  isMobile: PropTypes.bool,
  vdOptions: PropTypes.array,
  discountType: PropTypes.string,
  decimalSymbol: PropTypes.string,
  thousandSeparator: PropTypes.string,
  currencySymbol: PropTypes.string,
  currencyFormat: PropTypes.string,
};
